import React from 'react';
import LazyImage from '../components/LazyImage';
import '../styles/Gallery.css';

const Gallery = () => {
  const images = [
    { id: 1, url: require('../assets/images/DSC5849_.jpg'), alt: 'Photography 1' },
    { id: 2, url: require('../assets/images/DSC5583.jpg'), alt: 'Photography 2' },
    { id: 3, url: require('../assets/images/DSC5616.jpg'), alt: 'Photography 3' },
    { id: 4, url: require('../assets/images/DSC5409_1.jpg'), alt: 'Photography 4' },
    { id: 5, url: require('../assets/images/DSC5399_1.jpg'), alt: 'Photography 5' }
  ];

  return (
    <section id="gallery" className="gallery-section">
      <div className="container">
        <div className="gallery-header">
          <h2 className="gallery-title">
            BRINGING DREAMS TO <span className="text-brand">REALITY</span>
          </h2>
          <p className="gallery-subtitle">
            WHERE YOUR IDEAS MEET OUR VISION, CREATING EXTRAORDINARY MOMENTS THAT TRANSFORM IMAGINATION INTO STUNNING REALITY.
          </p>
        </div>

        <div className="gallery-strip">
          {images.map((image) => (
            <div key={image.id} className="gallery-strip-item">
              <LazyImage src={image.url} alt={image.alt} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
